export default __webpack_public_path__ + "static/media/view-invoices-img.d8892400.png";